module.exports = __webpack_public_path__ + "media/images/interviewee_smile-58ce2d16318f8a0843a176559c5ceac3.png";